module.exports = __webpack_public_path__ + "static/media/footer-email.c0afd5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-email.png
// module id = 1376
// module chunks = 42